import { device } from '@/utils/index'

const content = [
    // 第一章 第一节
    // 章标题
    {
        key: 'section2',
        type: "title",
        category: 1, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: "第<i style=\"font-family:'Times New Roman'; font-style: normal;\">2<\/i>章", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        // text: '文旌数字教材', // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book1/chapter-1.png"), // 标题图片
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/top_bg.png") // 背景图片  默认：无
        }
    },
    // 时间线组件
  {
    key: 'section1.1',
    type: "timeLine",
    shortText: "第<span style=\"font-family:'Times New Roman'\">2<\/span>章", // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: '文旌数字教材', // *必填* 标题文本内容
    titleImage: require("@/assets/images/bookContent/top_bg.png"), // 标题图片
    textStyle: {
      // fontFamily: 'Arial', // 字体，本地配置的字体
      // fontSize: 32, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#333', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      // backgroundImage: require("@/assets/images/bookContent/top_bg.png") // 背景图片  默认：无
    },
    content: [
      {
        key: 'section1.1.1',
        text: '模块导读',
        textStyle: {
          fontSize: device.isMobile ? 24 : 18,
          color: '#515151'
        },
        content: [
          {
            key: 'section1.1.1.1',
            category: "text",
            text: '机械图样是工程技术人员表达设计意图和设计方案的重要技术文件，它作为技术交流的共同语言，必须遵守统一的规范，即严格按照国家标准《技术制图》和《机械制图》的统一规定绘制，否则会阻碍生产和技术交流，甚至令其混乱。因此，在绘制机械图样前，应首先掌握国家标准《技术制图》与《机械制图》的基本规定，然后学习常用尺规绘图工具的使用方法、常用几何图形的画法、平面图形的分析与绘制方法，以及徒手绘图的方法等。',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          }
        ]
      },
      {
        key: 'section1.1.2',
        text: '知识目标',
        textStyle: {
          fontSize: device.isMobile ? 24 : 18,
          color: '#515151'
        },
        content: [
          {
            key: 'section1.1.2.1',
            category: "text",
            text: '掌握国家标准中关于图纸幅面和格式、比例、字体、图线的基本规定。',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          },
          {
            key: 'section1.1.2.2',
            category: "text",
            text: '了解尺寸标注的基本原则和组成要素，掌握常见的尺寸注法。',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          },
          {
            key: 'section1.1.2.3',
            category: "text",
            text: '掌握常用尺规绘图工具的使用方法和常用几何图形的画法。',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          },
          {
            key: 'section1.1.2.4',
            category: "text",
            text: '掌握平面图形的分析和绘制方法。',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          },
          {
            key: 'section1.1.2.5',
            category: "text",
            text: '掌握徒手绘图的方法。',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          }
        ]
      },
      {
        key: 'section1.1.3',
        text: '技能目标',
        textStyle: {
          fontSize: device.isMobile ? 24 : 18,
          color: '#515151'
        },
        content: [
          {
            key: 'section1.1.3.1',
            category: "text",
            text: '能够正确绘制各类图线和标注尺寸。 ',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          },
          {
            key: 'section1.1.3.2',
            category: "text",
            text: '能够用尺规绘图工具熟练绘制平面图形。',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          },
          {
            key: 'section1.1.3.3',
            category: "text",
            text: '能够用徒手绘图的方法绘制简单图形。',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          }
        ]
      },
      {
        key: 'section1.1.4',
        text: '素质目标',
        textStyle: {
          fontSize: device.isMobile ? 24 : 18,
          color: '#515151'
        },
        content: [
          {
            key: 'section1.1.4.1',
            category: "text",
            text: '严格执行机械制图有关国家标准的基本规定，养成认真、细致的作图习惯。 ',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          },
          {
            key: 'section1.1.4.2',
            category: "text",
            text: '培养脚踏实地、精益求精、科学严谨的工匠精神。 ',
            textStyle: {
              textIndent: '2em',
              fontSize: device.isMobile ? 24 : 18,
              color: '#1A1A1A'
            }
          }
        ]
      },
    ]
  },
   // 思维导图
   {
    key: 'section8.8', // *必填* 唯一标识
    type: 'mindMap', // *必填* 类型：思维导图
    height: 387,
    content: {
      // 思维导图 的数据
      "data": {
        "text": "模块一 机械制图的基本知识与技能",
      },
      "children": [
        {
          "data": {
            "id":"section4",
            "text":"任务一  认识与机械制图有关的国家标准",
            "richText": false,
            "expand": false,
          },
          "children":[
            {
              "data": {
                "id":"e3ka7wjjre",
                "text":"一、图纸幅面和格式",
                "richText": false,
                "type":"highlight"
              },
              "children":[
                {
                    "data": {
                      "id":"e3ka7wjsre",
                      "text":"1．图纸幅面",
                      "richText": false,
                      "type":"highlight"
                    }
                  },
                  {
                    "data": {
                      "id":"e3ka7wjsre",
                      "text":"2．图框格式",
                      "richText": false,
                      "type":"highlight"
                    }
                  },
                  {
                    "data": {
                      "id":"e3ka7wjsre",
                      "text":"3．标题栏",
                      "richText": false,
                      "type":"highlight"
                    }
                  },
              ]
            },
            {
                "data": {
                  "id":"e3ka7wjsre",
                  "text":"二、比例",
                  "richText": false,
                  "type":"highlight"
                },
                
              },
              {
                "data": {
                  "id":"e3ka9wjsre",
                  "text":"三、字体",
                  "richText": false,
                  "type":"highlight"
                },
                "children":[
                    {
                        "data": {
                          "id":"e3ka7wjsre",
                          "text":"1．汉字",
                          "richText": false,
                          "type":"highlight"
                        }
                      },
                      {
                        "data": {
                          "id":"e3ka7wjsre",
                          "text":"2．字母和数字",
                          "richText": false,
                          "type":"highlight"
                        }
                      },
                  ]
              },
              {
                "data": {
                  "id":"e3ka7wjsre",
                  "text":"四、图线",
                  "richText": false,
                  "type":"highlight"
                },
                "children":[
                    {
                        "data": {
                          "id":"e3ka7wjsre",
                          "text":"1．图线的用途",
                          "richText": false,
                          "type":"highlight"
                        }
                      },
                      {
                        "data": {
                          "id":"e3ka7wjsre",
                          "text":"2．图线的画法及注意事项",
                          "richText": false,
                          "type":"highlight"
                        }
                      },
                  ]
              },
              {
                "data": {
                  "id":"e3ka7wjsre",
                  "text":"五、尺寸标注",
                  "richText": false,
                  "type":"highlight"
                },
                "children":[
                    {
                        "data": {
                          "id":"e3ka7wjsre",
                          "text":"1．尺寸标注的基本原则",
                          "richText": false,
                          "type":"highlight"
                        }
                      },
                      {
                        "data": {
                          "id":"e3ka7wjsre",
                          "text":"2．尺寸标注的组成要素",
                          "richText": false,
                          "type":"highlight"
                        }
                      },
                      {
                        "data": {
                          "id":"e3ka7wjsre",
                          "text":"3．常见的尺寸注法",
                          "richText": false,
                          "type":"highlight"
                        }
                      },
                  ]
              },
          ]
        },
        {
          "data": {
            "id":"section1",
            "text":"任务二  绘制平面图形",
            "richText": false,
            "expand": false,
          },
          "children":[
            {
              "data": {
                "id":"section1.1",
                "text":"一、常用尺规绘图工具及其使用",
                "richText": false,
              },
              "children":[
                {
                  "data": {
                    "id":"0esa0jonr9er",
                    "text":"1．图板与丁字尺",
                    "richText": false,
                  }
                },
                {
                    "data": {
                      "id":"0esa0jonr9er",
                      "text":"2．三角板",
                      "richText": false,
                    }
                  },
                  {
                    "data": {
                      "id":"0esa0jonr9er",
                      "text":"3．圆规",
                      "richText": false,
                    }
                  },
                  {
                    "data": {
                      "id":"0esa0jonr9er",
                      "text":"4．分规",
                      "richText": false,
                    }
                  },
                  {
                    "data": {
                      "id":"0esa0jonr9er",
                      "text":"5．绘图铅笔",
                      "richText": false,
                    }
                  },
                  {
                    "data": {
                      "id":"0esa0jonr9er",
                      "text":"6．图纸",
                      "richText": false,
                    }
                  }
              ]
            }, 
            {
              "data": {
                "id":"section1.2",
                "text":"二、常用几何图形的画法",
                "richText": false,
              },
              "children":[
                {
                  "data": {
                    "id":"0esa0jonr3er",
                    "text":"1．等分线段的画法",
                    "richText": false,
                  }
                },
                {
                    "data": {
                      "id":"0esa0jonr3er",
                      "text":"2．等分圆的画法",
                      "richText": false,
                    }
                  },
                  {
                    "data": {
                      "id":"0esa0jonr3er",
                      "text":"3．圆（或圆弧）切线的画法",
                      "richText": false,
                    }
                  },
                  {
                    "data": {
                      "id":"0esa0jonr3er",
                      "text":"4．斜度与锥度的画法",
                      "richText": false,
                    }
                  },
                  {
                    "data": {
                      "id":"0esa0jonr3er",
                      "text":"5．椭圆的近似画法",
                      "richText": false,
                    }
                  }
              ]
            },
            {
                "data": {
                  "id":"section1.2",
                  "text":"三、平面图形的分析与绘制",
                  "richText": false,
                },
                "children":[
                  {
                    "data": {
                      "id":"0esa0jonr3er",
                      "text":"1．尺寸分析",
                      "richText": false,
                    }
                  },
                  {
                      "data": {
                        "id":"0esa0jonr3er",
                        "text":"2．线段分析",
                        "richText": false,
                      }
                    },
                    {
                      "data": {
                        "id":"0esa0jonr3er",
                        "text":"3．绘图的方法和步骤",
                        "richText": false,
                      }
                    },
                ]
              },
              {
                "data": {
                  "id":"section1.2",
                  "text":"四、徒手绘图",
                  "richText": false,
                },
                "children":[
                  {
                    "data": {
                      "id":"0esa0jonr3er",
                      "text":"1．直线的徒手画法",
                      "richText": false,
                    }
                  },
                  {
                      "data": {
                        "id":"0esa0jonr3er",
                        "text":"2．常用角度线的徒手画法",
                        "richText": false,
                      }
                    },
                    {
                      "data": {
                        "id":"0esa0jonr3er",
                        "text":"3．圆的徒手画法",
                        "richText": false,
                      }
                    },
                    {
                        "data": {
                          "id":"0esa0jonr3er",
                          "text":"4．椭圆的徒手画法",
                          "richText": false,
                        }
                      },
                      {
                        "data": {
                          "id":"0esa0jonr3er",
                          "text":"5．圆角和连接圆弧的徒手画法",
                          "richText": false,
                        }
                      },
                ]
              }
          ]
        },
      ]
    },
    title:'',
    // width: 'xxxx', // 内容区域宽度 非必填 默认100%
    titleStyle: {

    }
  },
    // 节标题
    {
        key: 'section2.1',
        type: "title",
        category: 2, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        shortText: "任务一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '认识与机械制图有关的国家标准', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: device.isMobile ? 26 : 18, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    // 小标题
    {
        key: 'section2.1.1',
        type: "title",
        category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "任务引入", // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book1/title-back.png"),
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: device.isMobile ? 26 : 18, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            textIndent: 80, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        },
    },
    {
        key: 'section2.1.2', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.1.2.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-1图样.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-1<\/i> 图 样", // 图片标题
                // titlePosition: 'top', // 标题位置， 默认为bottom
                hasBack: 1,
                titleStyle: {

                }
            }
        ],
    },
    {
        key: 'section2.1.3', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.1.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '某大学毕业生张强的职业目标是成为一名优秀的机械工程技术人员，他最近参加了一家机械设计公司的面试，面试官为了检验他对国家标准的掌握情况，让他指出图样（见图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section1.2.9.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section1.2.9.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）中的错误。请帮他指出该图样中的错误，并改正这些错误。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    {
        key: 'section2.1.4', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.1.4.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '本任务首先介绍国家标准中关于图纸幅面和格式、比例、字体、图线的基本规定，然后介绍尺寸标注的基本知识。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    {
        key: 'section2.2.0', // *必填* 唯一标识
        type: 'workOrder', // *必填* 类型：任务工单
        title: "任务工单<i style=\"font-family:'Times New Roman'; font-style: normal;\">1.1<\/i> —— 机械制图基础练习", // 标题
        content: [
            {
                key: 'section2.2.0.0',
                type: "title",
                category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '一、本课程的研究对象', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 48,
                },
            },
            {
                key: 'section2.2.0.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.1.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '根据机械制图国家标准的基本规定，进行简单图线的绘制，并按照尺寸标注的基本原则和方法标注尺寸。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            {
                key: 'section2.2.0.2', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.2.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.2.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.2.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）不同线型和线宽的图线是机械图样中的基本组成元素，请将如图', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.2.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.2.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '所示的图线抄绘一遍并标注尺寸。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            // 图片
            {
                key: 'section2.2.0.3', // *必填* 唯一标识
                type: 'image', // *必填* 类型：正文
                templateType: 1,
                content: [ // *必填* 图片列表
                    {
                        key: 'section2.2.0.3.1', // *必填* 唯一标识
                        url: require("@/assets/images/books/book1/workOrder/img-1.png"), // *必填* 图片地址
                        title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1<\/i>  抄绘图线并标注尺寸", // 图片标题
                        maxWidth: 350,
                        titleStyle: {

                        }
                    }
                ],
            },
            {
                key: 'section2.2.0.4', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.4.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.4.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '2', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.4.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）直尺和量角器是绘制机械图样的常用工具，请用这两种工具量取图', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.4.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '2', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.4.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '中的尺寸（取整数），并将尺寸标注在给定的尺寸线上。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            // 图片
            {
                key: 'section2.2.0.5', // *必填* 唯一标识
                type: 'image', // *必填* 类型：正文
                templateType: 1,
                content: [ // *必填* 图片列表
                    {
                        key: 'section2.2.0.5.1', // *必填* 唯一标识
                        url: require("@/assets/images/books/book1/workOrder/img-2.png"), // *必填* 图片地址
                        title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">2<\/i>  量取尺寸并进行标注", // 图片标题
                        titleStyle: {

                        }
                    }
                ],
            },
            {
                key: 'section2.2.0.6',
                type: "title",
                category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '二、学生分组', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 48,
                },
            },
            {
                key: 'section2.2.0.7', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.7.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '以', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.7.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '5～6', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.7.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '人为一组，选出组长并进行任务分工，将小组概况及分工填入表', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.7.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.7.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '中。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            // 任务工单 表格1
            {
                key: 'section2.2.0.8',
                type: "workOrderTable1", // *必填* 类型：任务工单 表格1
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1<\/i> 小组概况及分工", // *必填* 标题文本内容
            },
            {
                key: 'section2.2.0.9',
                type: "title",
                category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '三、任务准备', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 48,
                },
            },
            {
                key: 'section2.2.0.9.1',
                type: "title",
                category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: "<i style=\"font-family:'Times New Roman'; font-style: normal;\">1<\/i>．获取信息", // *必填* 标题文本内容
                textStyle: {
                    marginTop: 10,
                },
            },
            {
                key: 'section2.2.0.9.2', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.9.2.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '在进行机械制图基础练习之前，需要熟悉机械制图国家标准的基本规定。请各组组长组织组员收集有关资料，回答下列问题。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            // 任务工单 答题
            {
                key: 'section2.2.0.9.4',
                type: "workOrderQuestion", // *必填* 类型：任务工单 答题
                content: [
                    {
                        key: 'section2.2.0.9.4.1',
                        guideChapter: 'chapter1sub1',
                        guide: 'section2.3.2',
                        type: 'completion',
                        content: [
                            {
                                key: 'section2.2.0.9.4.1.1',
                                type: 'text',
                                text: '图纸幅面简称图幅，是指由图纸'
                            },
                            {
                                key: 'section2.2.0.9.4.1.2',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section2.2.0.9.4.1.3',
                                type: 'text',
                                text: '与'
                            },
                            {
                                key: 'section2.2.0.9.4.1.4',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section2.2.0.9.4.1.5',
                                type: 'text',
                                text: '组成的图面，用图纸的短边 x 长边（'
                            },
                            {
                                key: 'section2.2.0.9.4.1.6',
                                type: 'text',
                                text: 'B x L',
                                fontItalic:1,
                               
                            },
                            {
                                key: 'section2.2.0.9.4.1.7',
                                type: 'text',
                                text: '）表示。'
                            },
                        ]
                    },
                    {
                        key: 'section2.2.0.9.4.2',
                        guideChapter: 'chapter1sub1',
                        guide: 'section2.4.0',
                        type: 'completion',
                        content: [
                            {
                                key: 'section2.2.0.9.4.2.1',
                                type: 'text',
                                text: '比例是指图样中'
                            },
                            {
                                key: 'section2.2.0.9.4.2.2',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section2.2.0.9.4.2.3',
                                type: 'text',
                                text: '与'
                            },
                            {
                                key: 'section2.2.0.9.4.2.4',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section2.2.0.9.4.2.5',
                                type: 'text',
                                text: '相应要素的线性尺寸之比。'
                            },
                        ]
                    },
                    {
                        key: 'section2.2.0.9.4.3',
                        guideChapter: 'chapter1sub1',
                        guide: 'section2.7.7',
                        type: 'completion',
                        content: [
                            {
                                key: 'section2.2.0.9.4.3.1',
                                type: 'text',
                                text: '一个完整的尺寸标注应由'
                            },
                            {
                                key: 'section2.2.0.9.4.3.2',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section2.2.0.9.4.3.3',
                                type: 'text',
                                text: '、'
                            },
                            {
                                key: 'section2.2.0.9.4.3.4',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section2.2.0.9.4.3.5',
                                type: 'text',
                                text: '与'
                            },
                            {
                                key: 'section2.2.0.9.4.3.6',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section2.2.0.9.4.3.7',
                                type: 'text',
                                text: '三个要素组成。'
                            },
                        ]
                    },
                    {
                        key: 'section2.2.0.9.4.4',
                        guideChapter: 'chapter1sub1',
                        guide: 'section2.6.0',
                        type: 'shortAnswer',
                        questionText: '简述粗实线、细实线、虚线、细点画线在图样中的主要用途。',
                        answer: ''
                    },
                    {
                        key: 'section2.2.0.9.4.5',
                        guideChapter: 'chapter1sub1',
                        guide: 'section2.7.0',
                        type: 'shortAnswer',
                        questionText: '简述尺寸标注的基本原则。',
                        answer: ''
                    },
                ],
                textStyle: {},
            },
            {
                key: 'section2.2.0.9.5',
                type: "title",
                category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: "<i style=\"font-family:'Times New Roman'; font-style: normal;\">2<\/i>．制订计划", // *必填* 标题文本内容
                textStyle: {
                    marginTop: 30,
                },
            },
            {
                key: 'section2.2.0.9.6', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.9.6.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '查阅机械制图国家标准及有关资料，了解国家标准中关于图纸幅面和格式、比例、字体、图线的基本规定，以及尺寸标注的基本原则和组成要素，制订实施计划。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            {
                key: 'section2.2.0.9.7',
                type: "title",
                category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: "<i style=\"font-family:'Times New Roman'; font-style: normal;\">3<\/i>．进行决策", // *必填* 标题文本内容
                textStyle: {
                    marginTop: 20,
                },
            },
            {
                key: 'section2.2.0.9.8', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.9.8.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.9.8.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.9.8.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）每位学生阐述自己的计划。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            {
                key: 'section2.2.0.9.9', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.9.9.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.9.9.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '2', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.9.9.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）组员之间进行提问与答疑，制订本组的最佳实施计划。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            {
                key: 'section2.2.0.9.10', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.9.10.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.9.10.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '3', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.9.11.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）教师根据各组完成情况进行点评。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            {
                key: 'section2.2.0.10',
                type: "title",
                category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '四、任务实施', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 20,
                },
            },
            {
                key: 'section2.2.0.10.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.10.1.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '按照实施计划进行机械制图基础练习。按实际实施过程，将实施步骤、遇到的问题及解决办法等全部记录于表', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.10.1.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '2', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.10.1.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '中。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            // 任务工单 表格2
            {
                key: 'section2.2.0.10.2',
                type: "workOrderTable2", // *必填* 类型：任务工单 表格1
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">2<\/i>  工作实施过程记录表", // *必填* 标题文本内容
            },
            {
                key: 'section2.2.0.11',
                type: "title",
                category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '五、任务小结', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 20,
                },
            },
            {
                key: 'section2.2.0.11.1',
                type: "formTextarea",
            },
        ]
    },
    {
        key: 'section2.2.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.2.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '《技术制图》和《机械制图》等一系列国家标准，对图样的内容、格式、表示方法和画法等都进行了统一规定，每一名工程技术人员都应自觉贯彻执行。国家标准《技术制图》是基础技术标准，在制图标准中处于最高层次，具有通用性，适用于各类制图。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    {
        key: 'section2.3.0',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '一、图纸幅面和格式', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    {
        key: 'section2.3.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.3.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '国家标准', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.1.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'GB/T 14689—2008', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.1.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '《技术制图  图纸幅面和格式》规定了图纸的幅面尺寸和格式，以及有关的附加符号。在该标准的编号中，“', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.1.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'GB/T', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.1.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '”表示推荐性国家标准，“', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.1.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '14689', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.1.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '”为该标准的顺序号，“', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.1.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2008', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.1.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '”为该标准的发布年份。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    {
        key: 'section2.3.2',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '1．图纸幅面', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    {
        key: 'section2.3.3', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.3.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '图纸幅面简称图幅，是指由图纸宽度与长度组成的图面，用图纸的短边长边（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.3.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.3.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'x', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.3.2.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'L', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.3.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）表示。图纸的基本幅面共有五种，分别用幅面代号', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.3.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'A0、A1、A2、A3、A4', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.3.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '表示，如表', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.3.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.3.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    // 图片
    {
        key: 'section2.3.4', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.3.4.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/表1-1图纸的基本幅面及尺寸.png"), // *必填* 图片地址
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-1<\/i> 图纸的基本幅面及尺寸", // 图片标题
                subtitle: "单位：mm",
                titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    {
        key: 'section2.3.5', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.3.5.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '绘制机械图样时，图纸可以横放，也可以竖放，但应优先选用基本幅面，必要时也允许选用由基本幅面成整数倍增加短边尺寸后所得到的加长幅面，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.5.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.5.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    // 图片
    {
        key: 'section2.3.6', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.3.6.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-2加长幅面.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-2<\/i>  加长幅面", // 图片标题
                //titlePosition: 'top', // 标题位置， 默认为bottom
                hasBack: 1,
                titleStyle: {

                }
            }
        ],
    },
    // 视频
    {
        key: 'section2.3.7', // *必填* 唯一标识
        type: 'video', // *必填* 类型：视频
        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        content: [ // *必填* 视频列表
            {
                key: 'section2.3.6.1', // *必填* 唯一标识
                url: require("@/assets/video/图1-2动画.mp4"), // *必填* 视频地址
                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                title: '图1-2 动画', // 视频标题
                subtitle: '视频资源:', // 视频副标题 只在全部显示时使用
                titleStyle: {
                    // 根据需要是否加标题样式
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                }
            },

        ],
    },
    //标题
    {
        key: 'section2.3.8',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '2．图框格式', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    {
        key: 'section2.3.9', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.3.9.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '图框是指图纸上限定绘图区域的线框。图框在图纸上必须用粗实线画出，其格式分为留装订边（见图 ', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.9.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.9.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）和不留装订边（见图 ', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.9.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-4', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.9.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）两种，同一产品的图样只能采用一种图框格式。其中，', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section2.3.9.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'a、c、e', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.9.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '均代表周边尺寸，即图框线到图纸界线的距离，可参见表', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section2.3.9.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.9.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '。', // *必填* 文本内容
                textStyle: {

                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    // 图片
    {
        key: 'section2.3.10', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.3.10.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-3留装订边的图框格式.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-3<\/i>  留装订边的图框格式", // 图片标题
                //titlePosition: 'top', // 标题位置， 默认为bottom
                hasBack: 1,
                titleStyle: {

                }
            }
        ],
    },
    // 图片
    {
        key: 'section2.3.11', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.3.11.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-4不留装订边的图框格式.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-4<\/i>  不留装订边的图框格式", // 图片标题
                //titlePosition: 'top', // 标题位置， 默认为bottom
                hasBack: 1,
                titleStyle: {

                }
            }
        ],
    },
    //笔记内容
    {
        key: 'section2.3.12',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '文旌数字教材', // *必填* 标题文本内容
        category: 'frame_textarea', //
        titleBg: {
            key: 'section2.3.12.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_note_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 48,
            },
        },
        content: [{
            key: 'section2.3.12.2', // *必填* 唯一标识
            category: '',
            hasBack: 1, // 是否存在背景 背景默认为白色背景黑色描边 1：存在 2：不存在
            placeholder: '请输入你的笔记',
            value: '',
            titleStyle: {

            }
        }, ]
    },
    {
        key: 'section2.3.13',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '3．标题栏', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.3.14', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.3.14.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '常见的标题栏有两种，一种是国家标准', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.14.2', // *必填* 唯一标识
                category: 'link', // *必填* 内容类型 text：文本
                text: 'GB/T 10609.1—2008《技术制图  标题栏》', // *必填* 文本内容
                link: "https://openstd.samr.gov.cn/bzgk/gb/newGbInfo?hcno=0F8577CB9AB82D5819048A87920CABAB",
                textStyle: {

                },
            },
            {
                key: 'section2.3.14.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '中规定的标题栏，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.14.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-5', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.14.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示；另一种是学校制图作业中使用的简化标题栏，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.3.14.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-6', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.14.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。每张图纸都必须绘制标题栏，它通常位于图纸的右下角，标题栏中文字的方向为读图方向。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    // 图片
    {
        key: 'section2.3.15', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.3.15.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-5  国家标准中规定的标题栏.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-5<\/i>  国家标准中规定的标题栏", // 图片标题
                //titlePosition: 'top', // 标题位置， 默认为bottom
                hasBack: 1,
                titleStyle: {

                }
            }
        ],
    },
    // 图片
    {
        key: 'section2.3.16', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.3.15.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-6  学校制图作业中使用的简化标题栏.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-6<\/i>  学校制图作业中使用的简化标题栏", // 图片标题
                //titlePosition: 'top', // 标题位置， 默认为bottom
                hasBack: 1,
                titleStyle: {

                }
            }
        ],
    },
    {
        key: 'section2.4.0',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '二、比例', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.4.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.4.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '比例是指图样中图形与实物相应要素的线性尺寸之比。为了在图样上直接反映实物的大小，绘图时应尽量采用原值比例', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.4.1.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1∶1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.4.1.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '。由于各种实物的大小和结构存在差异，绘图时可根据实际需要选取放大比例或缩小比例。', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.4.1.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'GB/T 14690—1993', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.4.1.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '《技术制图  比例》规定，绘制图样时应优先选取表', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.4.1.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.3.1.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '中的第一系列比例，必要时也可选取第二系列比例。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //问题模块内容
    {
        key: 'section2.4.2',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_answer', //
        titleBg: {
            key: 'section2.4.2.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_issue_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 50,
            },
        },
        content: [{
                key: 'section2.4.2.2', // *必填* 唯一标识
                category: 'frame_cxtd',
                textStyle: {
                    color: '#333333',
                    fontSize: device.isMobile ? 26 : 18,
                    lineHeight: 44,
                    textIndent: 35,
                    fontFamily: 'Microsoft YaHei',
                    fontWeight: 'bold'
                },
                fontContent: [{
                        key: 'section2.4.2.2.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '在什么情况下会选择放大比例或缩小比例，而不是原值比例', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontWeight: 'bold'
                        },
                    },
                    {
                        key: 'section2.4.2.2.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1:1', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontWeight: 'bold',
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.4.2.2.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '？', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontWeight: 'bold'
                        },
                    },
                ]
            },
            {
                key: 'section2.4.2.3', // *必填* 唯一标识
                category: 'frame_cxtd',
                textStyle: {
                    color: '#333333',
                    fontSize: device.isMobile ? 26 : 18,
                    lineHeight: 44,
                    textIndent: 40,
                    fontFamily: 'Microsoft YaHei',
                },
                fontContent: [{
                        key: 'section2.4.2.3.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '当实物的尺寸非常大或非常小，以至于使用', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                        },
                    },
                    {
                        key: 'section2.4.2.3.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1:1', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section2.4.2.3.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '比例绘图不实际或不可能时，会选择放大或缩小比例。例如，对于大型结构如桥梁或小型精密零件，使用放大或缩小比例可以使得图纸更易于阅读和处理。此外，当需要在有限的空间内展示复杂的结构时，也可能会采用比例缩放。', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                        },
                    },
                ]
            },
        ]
    },
    // // 视频
    // {
    //   key: 'section2.4.2', // *必填* 唯一标识
    //   type: 'video', // *必填* 类型：视频
    //   templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
    //   styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
    //   content: [ // *必填* 视频列表
    //     {
    //       key: 'section2.4.2.1', // *必填* 唯一标识
    //       url: require("@/assets/video/图1-2动画.mp4"), // *必填* 视频地址
    //       left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
    //       title: '这是问题111', // 视频标题
    //       subtitle: '这是问题1111占位', // 视频副标题 只在全部显示时使用
    //       titleStyle: {

    //       }
    //     },

    //   ],
    // },
    // 图片
    {
        key: 'section2.4.3', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.4.3.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/表1-2比例.png"), // *必填* 图片地址
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-2<\/i>  比  例", // 图片标题
                titlePosition: 'top', // 标题位置， 默认为bottom
                // hasBack: 1,
                titleStyle: {

                }
            }
        ],
    },
    // 交互 连连看
    {
        key: 'section2.4.4', // *必填* 唯一标识
        type: 'action', // *必填* 类型：交互
        actionType: 1, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
        title: '连一连  GB/T 14690—1993中', // 标题
        titleStyle: {},
        isBlock: 1, // 是否默认存在一个区域框
        content: {
            // 连连看
            key: 'action1',
            info: '请拖动下方备选项，以完成左侧问题和右侧答案的一一对应',
            leftData: [{
                key: 'action1.1',
                actionKey: 'action1',
                cover: require("@/assets/images/books/book1/action/connection-left-1.png"),
                answerKey: 'key1'
            },
            {
                key: 'action1.2',
                actionKey: 'action1',
                cover: require("@/assets/images/books/book1/action/connection-left-2.png"),
                answerKey: 'key2'
            },
            {
                key: 'action1.3',
                actionKey: 'action1',
                cover: require("@/assets/images/books/book1/action/connection-left-3.png"),
                answerKey: 'key3'
            }
            ],
            rightData: [{
                key: 'action1.4',
                actionKey: 'action1',
                text: '推荐性国家标准',
                answerKey: 'key1'
            },
            {
                key: 'action1.5',
                actionKey: 'action1',
                text: '强制性国家标准',
                answerKey: 'key4'
            },
            {
                key: 'action1.6',
                actionKey: 'action1',
                text: '修订年份',
                answerKey: 'key5'
            },
            {
                key: 'action1.7',
                actionKey: 'action1',
                text: '国家标准指导性技术文件',
                answerKey: 'key6'
            },
            {
                key: 'action1.8',
                actionKey: 'action1',
                text: '顺序号',
                answerKey: 'key2'
            },
            {
                key: 'action1.9',
                actionKey: 'action1',
                text: '序列号',
                answerKey: 'key7'
            },
            {
                key: 'action1.10',
                actionKey: 'action1',
                text: '发布年份',
                answerKey: 'key3'
            }
            ],

        },
    },
    //点拔
    {
        key: 'section2.4.5',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_section', //
        titleBg: {
            key: 'section2.4.5.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_give_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 47,
            },
        },
        content: [{
            key: 'section2.4.5.2', // *必填* 唯一标识
            category: 'frame_cxtd',
            // text: '通常情况下，绘图铅笔铅芯的软硬程度可根据其粗细来识别：铅芯越粗，说明其越软；反之，铅芯越细，说明其越硬。绘图时，画圆弧的铅芯通常比画直线的铅芯软一些，以保证图线的颜色深度相一致。',
            textStyle: {
                color: '#1A1A1A',
                fontSize: device.isMobile ? 26 : 18,
                lineHeight: 44,
                textIndent: '2em',
                fontFamily: 'SimSun',
                fontWeight: 400
            },
            fontContent: [{
                key: 'section2.4.5.3', // *必填* 唯一标识
                category: 'text',
                text: '无论用放大比例还是用缩小比例进行绘图，图样中标注的尺寸都应为物体的实际尺寸，与绘图比例无关。绘制机械图样时，绘图比例一般应注写在标题栏中的“比例”栏内，必要时也可标注在图形的下方或右侧。',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            }]
        }, ]
    },
    {
        key: 'section2.5.0',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '三、字体', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.5.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.5.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '字体是指图样中汉字、字母和数字的书写形式。在图纸上写字时，应根据需要选择合适的字号。', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.1.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'GB/T 14691—1993', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.1.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '《技术制图  字体》规定，字号用字体的高度（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.1.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'h', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.1.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）表示，通常在其公称尺寸系列', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.1.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1.8 mm、2.5 mm、3.5 mm、5 mm、7 mm、10 mm、14 mm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.1.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.1.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '20 mm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.1.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '中选取。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    {
        key: 'section2.5.2',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '1．汉字', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.5.3', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.5.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '汉字应写成长仿宋体字，并采用国家正式公布推行的《汉字简化方案》中规定的简化字。汉字的高度', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.3.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'h', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.3.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '不应小于', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.3.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3.5 mm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.3.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，其字宽一般为', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.3.6', // *必填* 唯一标识
                category: 'image', // *必填* 内容类型 text：文本
                url: require("@/assets/images/books/book1/chapter1/图片公式2.png"), // *必填* 文本内容
                width: 35,
                position: 'inline',
                verticalAlign: 'middle'
            },
            {
                key: 'section2.5.1.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    {
        key: 'section2.5.4',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_answer', //
        titleBg: {
            key: 'section2.5.4.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_issue_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 50,
            },
        },
        content: [{
                key: 'section2.5.4.2', // *必填* 唯一标识
                category: 'frame_cxtd',
                textStyle: {
                    color: '#333333',
                    fontSize: device.isMobile ? 26 : 18,
                    lineHeight: 44,
                    textIndent: 40,
                    fontWeight: 'bold'
                },
                fontContent: [{
                        key: 'section2.5.4.2.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '在技术制图中，为什么汉字的高度不应小于', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                            fontWeight: 'bold'
                        },
                    },
                    {
                        key: 'section2.5.4.2.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '3.5mm', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                            fontWeight: 'bold',
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.5.4.2.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '？', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                            fontWeight: 'bold'
                        },
                    },
                ]
            },
            {
                key: 'section2.5.4.3', // *必填* 唯一标识
                category: 'frame_cxtd',
                textStyle: {
                    color: '#333333',
                    fontSize: device.isMobile ? 26 : 18,
                    lineHeight: 44,
                    textIndent: 52,
                },
                fontContent: [{
                        key: 'section2.5.4.3.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '汉字的高度不应小于', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                        },
                    },
                    {
                        key: 'section2.5.4.3.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '3.5mm', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section2.5.4.3.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '是为了确保图纸上的汉字清晰可读。较小的字号可能在打印或复印时变得模糊不清，影响图纸的可读性和信息的准确传达。此外，较大的字号有助于在视觉上区分不同的文本元素，提高图纸的整体可读性。', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                        },
                    },
                ]
            },
        ]
    },
    // // 视频
    // {
    //   key: 'section2.5.4', // *必填* 唯一标识
    //   type: 'video', // *必填* 类型：视频
    //   templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
    //   styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
    //   content: [ // *必填* 视频列表
    //     {
    //       key: 'section2.5.4', // *必填* 唯一标识
    //       url: require("@/assets/video/图1-2动画.mp4"), // *必填* 视频地址
    //       left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
    //       title: '这是问题占位', // 视频标题
    //       subtitle: '这是问题占位', // 视频副标题 只在全部显示时使用

    //     },

    //   ],
    // },
    {
        key: 'section2.5.5',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '2．字母和数字', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.5.6', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.5.6.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '字母和数字的字体有', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.6.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'A', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.6.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '型和', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.6.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.6.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '型两种。其中，', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.6.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'A', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.6.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '型字体的笔画宽度（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.6.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'd', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.6.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）为字高（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.6.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'h', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.6.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）的十四分之一，', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.6.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.6.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '型字体的笔画宽度（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.6.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'd', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.6.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）为字高（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.6.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'h', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.6.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）的十分之一。在同一图样上只允许采用一种型式的字体。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.5.7', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.5.7.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '字母和数字可以写成直体字或斜体字。斜体字字头向右倾斜，与水平基线成', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.7.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '75°', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.7.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '。当字母和数字用于表示指数、分数、极限偏差等时，一般应采用比基本字体小一号的字体。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.5.8', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.5.8.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '在图纸上写字时，必须做到字体工整、笔画清楚、间隔均匀、排列整齐。为了达到这些要求，需要注意以下事项。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.5.9', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.5.9.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.9.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.9.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）用', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.9.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'H', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.9.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '或', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.9.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'HB', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.9.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '铅笔写字，并将铅笔削成圆锥形，笔尖不要太尖或太秃。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.5.10', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.5.10.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.10.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.10.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）根据所选字号用', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.10.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2H', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.10.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '或', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.10.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3H', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.10.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的铅笔打好底格，底格宜浅不宜深，以能看清为准。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.5.11', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.5.11.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.11.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.11.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）字体的笔画宜直不宜曲，起笔和收笔不要追求刀刻效果，要大方简洁。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.5.12', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.5.12.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.12.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '4', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.11.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）字体的结构力求匀称、饱满，笔画间的空白要分布均匀。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.5.13', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.5.13.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '字体示例如表', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.5.13.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.5.13.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    // 图片
    {
        key: 'section2.5.14', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.5.14.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/表1-3字体示例.png"), // *必填* 图片地址
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-3<\/i>  字体示例", // 图片标题
                titlePosition: 'top', // 标题位置， 默认为bottom
                heightNoLimit: 1,
                titleStyle: {

                }
            }
        ],
    },
    {
        key: 'section2.6.0',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '四、图线', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    {
        key: 'section2.6.1',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '1．图线的用途', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.6.2', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.6.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '图纸中各种型式的线统称为图线。', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.2.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'GB/T 4457.4—2002', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.2.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '《机械制图  图样画法  图线》对机械图样中图线的名称、线型、线宽、用途及画法等均进行了规定。在机械图样中，用途不同的图线，其线型和线宽不同，如表', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.2.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-4', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.2.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。其中，图线的线宽有粗、细两种，两者之比为', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.2.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2∶1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.2.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '。粗线的线宽', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.2.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'd', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.2.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '应根据图样的大小和复杂程度在', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.2.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '0.25 mm、0.35 mm、0.5 mm、0.7 mm、1 mm、1.4 mm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.2.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.2.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2 mm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.2.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '中选取（优先选取', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.2.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '0.5 mm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.2.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '或', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.2.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '0.7 mm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.2.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    // 图片
    {
        key: 'section2.6.3', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.6.3.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/表1-4图线及其应用.png"), // *必填* 图片地址
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-4<\/i>  图线及其应用", // 图片标题
                titlePosition: 'top', // 标题位置， 默认为bottom
                heightNoLimit: 1,
                titleStyle: {

                }
            }
        ],
    },
    {
        key: 'section2.6.4',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '2．图线的画法及注意事项', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.6.5', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.6.5.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.5.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.5.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）在同一图样中，同类图线的线宽应基本一致。', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.5.4', // *必填* 唯一标识
                category: 'popover', // *必填* 内容类型 text：文本
                text: '虚线', // *必填* 文本内容
                popTitle: '虚线的线型',
                popText: '',
                popImage: require("@/assets/images/books/book1/chapter1/b1-4-4-1.jpg"),
                textStyle: {

                },
            },
            {
                key: 'section2.6.5.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.5.6', // *必填* 唯一标识
                category: 'popover', // *必填* 内容类型 text：文本
                text: '细点画线', // *必填* 文本内容
                popTitle: '细点画线的线型',
                popText: '',
                popImage: require("@/assets/images/books/book1/chapter1/b1-4-5.jpg"),
                textStyle: {

                },
            },
            {
                key: 'section2.6.5.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '及', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.5.8', // *必填* 唯一标识
                category: 'popover', // *必填* 内容类型 text：文本
                text: '双点画线', // *必填* 文本内容
                popTitle: '双点画线的线型',
                popText: '',
                popImage: require("@/assets/images/books/book1/chapter1/b1-4-6.jpg"),
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.5.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的线段长度和间距应大致相等。细点画线和双点画线的首尾两端应以线段开始和结束。', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.6.6', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.6.6.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.6.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.6.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）当细点画线、虚线彼此相交或与其他图线相交时，它们都应在线段处相交，不应在间隔处相交，如图', // *必填* 文本内容
                textStyle: {},
            },

            {
                key: 'section2.6.6.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-7', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.6.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.6.7', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.6.7.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.7.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.7.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）在较小的图形上绘制虚线、细点画线或双点画线困难时，可用细实线代替。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.6.8', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.6.8.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.8.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '4', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.8.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）当虚线在粗实线的延长线上时，粗实线要画到分界点，虚线则应在分界点处留空隙，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.8.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-7', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.8.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。当虚线直线与虚线圆弧相切时，虚线圆弧的线段应画到切点，而虚线直线则需要在切点处留空隙。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.6.9', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.6.9.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.9.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '5', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.9.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）绘制细点画线时，细点画线应超出图形轮廓线', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.9.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3～5 mm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.9.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，且首尾两端应为线段，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.6.9.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-7', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.6.9.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginBottom:30
        },

    },
    // 图片
    {
        key: 'section2.6.10', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.6.10.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-7图线画法示例.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-7<\/i>  图线画法示例", // 图片标题
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //笔记内容
    {
        key: 'section2.6.11',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '文旌数字教材', // *必填* 标题文本内容
        category: 'frame_textarea', //
        titleBg: {
            key: 'section2.6.11.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_note_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 48,
            },
        },
        content: [{
            key: 'section2.3.12.2', // *必填* 唯一标识
            category: '',
            hasBack: 1, // 是否存在背景 背景默认为白色背景黑色描边 1：存在 2：不存在
            placeholder: '请输入你的笔记',
            value: '',
            titleStyle: {

            }
        }, ]
    },
    {
        key: 'section2.7.0',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '五、尺寸标注', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.7.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '在机械图样中，图形只能表示物体的形状和结构。若要表示物体的大小及各部分之间的相对位置，则需要为其标注尺寸。由此可见，尺寸是机械图样的重要内容之一，是加工、制造零件的主要依据。标注尺寸时，应严格执行', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.1.2', // *必填* 唯一标识
                category: 'link', // *必填* 内容类型 text：文本
                text: 'GB/T 4458.4—2003《机械制图  尺寸注法》', // *必填* 文本内容
                link: "https://openstd.samr.gov.cn/bzgk/gb/newGbInfo?hcno=08588A5F3FE19F16B9EE8D5D87E064D5",
                textStyle: {

                },
            },
            {
                key: 'section2.6.7.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '中的有关规定，具体如下。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    {
        key: 'section2.7.2',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '1．尺寸标注的基本原则', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.7.3', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.3.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.3.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）机件的真实大小应以机械图样上所标注的尺寸为依据，与图形的大小和绘图的准确度无关。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.7.4', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.4.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.4.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.4.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）机械图样中所标注的尺寸以', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.4.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'mm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.4.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（毫米）为单位时，不需要标注单位符号或名称，若采用其他单位，则必须标注相应的单位符号，如', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.4.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'm、cm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.4.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '等。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section2.7.5', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.5.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.5.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.5.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）机械图样中所标注的尺寸应为该图样所示机件的最后完工尺寸，否则应另加说明。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.7.6', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.6.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.6.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '4', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.6.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）机件每个结构的尺寸一般只标注一次，并且应标注在最能清晰表示该结构的图形上。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    {
        key: 'section2.7.7',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '2．尺寸标注的组成要素', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.7.8', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.8.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '一个完整的尺寸标注应由尺寸界线、尺寸线及尺寸数字三个要素组成，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.8.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-8', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.8.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    // 图片
    {
        key: 'section2.7.9', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.7.9.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-8尺寸标注的组成要素.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-8<\/i>  尺寸标注的组成要素", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section2.7.10', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.10.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.10.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）尺寸界线', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.7.11', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.11.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '尺寸界线表示尺寸度量的范围，用细实线画出，并自图形的轮廓线、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.11.2', // *必填* 唯一标识
                category: 'popover', // *必填* 内容类型 text：文本
                text: '轴线', // *必填* 文本内容
                popTitle: '轴线的名词解释',
                popText: '图纸上的轴线通常是用粗实线（也有用虚线）标示出来的一条线，用于表示物体的几何中心轴线或旋转对称轴线。在机械设计中，轴线可以用来表示零件的轴向或旋转方向，方便零件的加工、装配和检测。在建筑设计中，轴线可以表示建筑物的中心线或对称轴线，方便建筑物的设计和施工。在工业设计中，轴线可以表示产品的主轴线或零部件的装配轴线，方便设计和生产。轴线在图纸上的表示是非常重要的，它能够传递设计意图，方便制造和生产。',
                textStyle: {

                },
            },
            {
                key: 'section2.7.11.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '或', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.11.4', // *必填* 唯一标识
                category: 'popover', // *必填* 内容类型 text：文本
                text: '对称中心线', // *必填* 文本内容
                popTitle: '对称中心线的名词解释',
                popText: '对称中心线‌是指在图形中，将图形绕某一点旋转180度后能够与原图形完全重合的点所形成的线。这个点称为对称中心，而连接对称中心的线则称为对称中心线。‌',
                textStyle: {

                },
            },
            {
                key: 'section2.7.11.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '处引出，也可将轮廓线、轴线或对称中心线作为尺寸界线。尺寸界线一般应与尺寸线垂直并超出尺寸线', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.11.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2～3 mm', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.11.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，必要时允许倾斜，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.11.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-9', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.11.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section2.7.12', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.7.12.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-9尺寸界线.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-9<\/i> 尺寸界线", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section2.7.13', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.13.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.13.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）尺寸线', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },

    },
    //正文
    {
        key: 'section2.7.14', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.14.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '尺寸线表示所标注尺寸的', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.14.2', // *必填* 唯一标识
                category: 'popover', // *必填* 内容类型 text：文本
                text: '度量方向', // *必填* 文本内容
                popTitle: '度量方向的名词解释',
                popText: '在机械制图中，度量方向通常指的是物体在空间中的三个主要方向：长度、宽度和高度。这些方向用于确定物体的尺寸和形状。',
                textStyle: {

                },
            },
            {
                key: 'section2.7.14.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，用细实线画在两条尺寸界线之间。机械图样上的尺寸线不能用其他图线代替，也不能与其他图线重合或画在其延长线上，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.14.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-10', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.14.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section2.7.15', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.7.15.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-10尺寸线.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-10<\/i>  尺寸线", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 视频
    {
        key: 'section2.7.16', // *必填* 唯一标识
        type: 'video', // *必填* 类型：视频
        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        content: [ // *必填* 视频列表
            {
                key: 'section2.7.16.1', // *必填* 唯一标识
                url: require("@/assets/video/图1-10动画.mp4"), // *必填* 视频地址
                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                title: '图1-10 动画', // 视频标题
                subtitle: '视频资源:', // 视频副标题 只在全部显示时使用
                titleStyle: {
                    // 根据需要是否加标题样式
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                }
            },

        ],
    },
    //点拔
    {
        key: 'section2.3.17',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_section', //
        titleBg: {
            key: 'section2.3.17.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_give_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 47,
            },
        },
        content: [{
            key: 'section2.4.5.2', // *必填* 唯一标识
            category: 'frame_cxtd',
            // text: '通常情况下，绘图铅笔铅芯的软硬程度可根据其粗细来识别：铅芯越粗，说明其越软；反之，铅芯越细，说明其越硬。绘图时，画圆弧的铅芯通常比画直线的铅芯软一些，以保证图线的颜色深度相一致。',
            textStyle: {
                color: '#1A1A1A',
                fontSize: device.isMobile ? 26 : 18,
                lineHeight: 44,
                textIndent: 40,
                fontFamily: 'SimSun',
                fontWeight: 400
            },
            fontContent: [{
                key: 'section2.4.5.3', // *必填* 唯一标识
                category: 'text',
                text: '当机械图样上需要标注的尺寸较多时，相互平行的尺寸线应按被标注图形轮廓线的远近顺序由近向远整齐排列，并遵循“小尺寸在内，大尺寸在外”的原则。',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight: 'bold'
                }
            }]
        }, ]
    },
    //正文
    {
        key: 'section2.7.18', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.18.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '尺寸线的终端有箭头和斜线两种形式，同一机械图样只能采用一种形式。机械图样中一般采用箭头作为尺寸线的终端，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.18.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-11', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.18.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section2.7.19', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.7.19.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-11尺寸线终端的箭头.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-11<\/i>  尺寸线终端的箭头", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section2.7.20', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.20.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.20.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）尺寸数字', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section2.7.21', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一
            {
                key: 'section2.7.21.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '尺寸数字用于确定所标注结构的尺寸大小。水平尺寸数字应注写在尺寸线上方；铅垂尺寸数字应注写在尺寸线的左方且字头朝左，也允许注写在尺寸线中断处。尺寸数字上不得通过任何图线，若无法避免，则必须将图线断开。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //笔记内容
    {
        key: 'section2.7.22',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '文旌数字教材', // *必填* 标题文本内容
        category: 'frame_textarea', //
        titleBg: {
            key: 'section2.7.22.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_note_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 48,
            },
        },
        content: [{
            key: 'section2.7.22.2', // *必填* 唯一标识
            category: '',
            hasBack: 1, // 是否存在背景 背景默认为白色背景黑色描边 1：存在 2：不存在
            placeholder: '请输入你的笔记',
            value: '',
            titleStyle: {

            }
        }, ]
    },
    {
        key: 'section2.7.23',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 4：居中带背景图的标题...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '3．常见的尺寸注法', // *必填* 标题文本内容
        textStyle: {
            // fontFamily: 'Arial', // 字体，本地配置的字体
            // fontSize: 32, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#1A1A1A', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            marginTop: 40,
            marginBottom: 15,
        }
    },
    //正文
    {
        key: 'section2.7.24', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.24.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.24.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）线性尺寸中尺寸数字的注法', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section2.7.25', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section2.7.25.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '线性尺寸的尺寸数字一般注写在尺寸线的上方或中断处，其注写方向如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.25.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-12', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.25.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.25.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'a', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.25.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示，同时应尽量避免在图中所示向左倾斜', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.25.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '30°', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.25.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的范围内标注尺寸。若无法避免，则应引出标注，或以水平方向注写在尺寸线的中断处，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.25.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-12', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.25.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.25.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'b', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.25.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section2.7.26', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.7.26.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-12线性尺寸中尺寸数字的注法.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-12<\/i>  线性尺寸中尺寸数字的注法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section2.7.27', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.27.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.27.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）半径和直径的尺寸注法', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section2.7.28', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.28.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '半圆和小于半圆的圆弧一般标注半径尺寸，其尺寸线由圆心引出，箭头指向圆弧，且尺寸数字前需要加注半径符号“', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.28.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.28.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '”，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.28.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-13', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.28.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.28.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'a', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.28.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示；当圆弧半径太大或无法标出圆心位置时，圆弧半径的标注方法如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.28.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-13', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.28.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.28.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'b', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.28.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section2.7.29', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.29.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '圆和大于半圆的圆弧需要标注直径尺寸。标注直径尺寸时，尺寸数字前需要加注直径符号“', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.29.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'EUCSYMBI', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.29.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '”，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.29.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-13', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.29.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.29.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'c', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.29.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。标注球体和球面的直径或半径尺寸时，应在符号“ ', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.29.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'EUCSYMBI', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.29.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '” 或 “', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.29.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.29.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '” 前再加注符号 “', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.29.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'S', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.29.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '” 。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section2.7.30', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.7.30.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-13半径和直径的尺寸注法.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-13<\/i>  半径和直径的尺寸注法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section2.7.31', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.31.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.31.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）角度的尺寸注法', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section2.7.32', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section2.7.32.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '标注角度时，角的两条边或两条边的延长线可作为尺寸界线，尺寸线应画成圆弧，角度数字一律以水平方向注写。一般情况下，角度数字应注写在尺寸线的中断处或尺寸线旁，必要时也可引出标注，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.32.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-14', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.32.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section2.7.33', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.7.33.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-14角度的尺寸注法.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-14<\/i>  角度的尺寸注法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section2.7.34', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.34.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '4', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.34.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）狭小部位的尺寸注法', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section2.7.35', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section2.7.35.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '当没有足够的空间画尺寸线两端的箭头时，尺寸线的箭头可外移，或用小圆点代替；当没有足够的空间注写尺寸数字时，尺寸数字可写在尺寸线的外面或从尺寸线引出，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.35.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-15', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.35.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section2.7.36', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.7.36.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-15狭小部位的尺寸注法.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-15<\/i>  狭小部位的尺寸注法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section2.7.37', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section2.7.37.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '5', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.37.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）对称图形的尺寸注法', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section2.7.38', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section2.7.38.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '当分布在中心线两侧的图形完全相同时，其标注方法如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.38.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-16', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.38.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.38.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'a', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.38.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示；当对称机件的图形只绘制出一半或略大于一半时，尺寸线应略超过对称中心线或断开处的边界，此时仅在尺寸线的一端画出箭头，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.38.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-16', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.38.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.38.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'b', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.38.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section2.7.39', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.7.39.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-16对称图形的尺寸注法.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-16<\/i>   对称图形的尺寸注法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section2.7.40', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section2.7.40.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '尺寸标注常用的符号及缩写词如表', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section2.7.40.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-5', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section2.7.40.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section2.7.41', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section2.7.41.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/表1-5尺寸标注常用的符号及缩写词.png"), // *必填* 图片地址
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-5<\/i>  尺寸标注常用的符号及缩写词", // 图片标题
                titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 小互动
    {
        key: 'section2.7.41.1',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_interact', //
        titleBg: {
            key: 'section2.7.41.1.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_interate_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 50,
            },
        },
        content: [
            // 交互 拼图/组装
            {
                key: 'section2.7.41.1.2', // *必填* 唯一标识
                type: 'action', // *必填* 类型：交互
                actionType: 4, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                title: '请点击下方三张图上标绿的位置，在弹出的选项中选择正确的符号。', // 标题
                titleStyle: {},
                isInBlock: 1,
                content: [
                    {
                        // 拼图/组装
                        key: 'section2.7.41.1.2.1', // *必填* 唯一标识
                        actionType: 4, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                        cover: require("@/assets/images/books/book1/action/jigsaw-back-1.png"),
                        width: 662,
                        height: 489,
                        content: [
                            {
                                top: 3,
                                left: 120,
                                width: 34,
                                height: 35,
                                hideCenterPoint: 1,
                                answerPosition: 'left', // 答案显示位置
                                answerKey: 'key2'
                            },
                            {
                                top: 154,
                                left: 301,
                                width: 34,
                                height: 35,
                                hideCenterPoint: 1,
                                answerPosition: 'left',
                                answerKey: 'key1'
                            }
                        ],
                        options: [
                            {
                                value: 'key1',
                                label: 'option1',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-1.png"),
                            },
                            {
                                value: 'key2',
                                label: 'option2',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-2.png"),
                            },
                            {
                                value: 'key3',
                                label: 'option3',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-3.png"),
                            },
                            {
                                value: 'key4',
                                label: 'option4',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-4.png"),
                            },
                            {
                                value: 'key5',
                                label: 'option5',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-5.png"),
                            },
                            {
                                value: 'key6',
                                label: 'option6',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-6.png"),
                            },
                            {
                                value: 'key7',
                                label: 'option7',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-7.png"),
                            },
                        ],
                    },
                    {
                        // 拼图/组装
                        key: 'section2.7.41.1.2.2', // *必填* 唯一标识
                        actionType: 4, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                        cover: require("@/assets/images/books/book1/action/jigsaw-back-2.png"),
                        width: 662,
                        height: 454,
                        content: [
                            {
                                top: 23,
                                left: 211,
                                width: 34,
                                height: 35,
                                hideCenterPoint: 1,
                                answerPosition: 'top',
                                answerKey: 'key1'
                            },
                            {
                                top: 51,
                                left: 133,
                                width: 34,
                                height: 35,
                                hideCenterPoint: 1,
                                answerPosition: 'left',
                                answerKey: 'key1'
                            },
                            {
                                top: 34,
                                left: 482,
                                width: 34,
                                height: 35,
                                hideCenterPoint: 1,
                                answerPosition: 'left',
                                answerKey: 'key2',
                                radioPosition: 'left'
                            },
                            {
                                top: 153,
                                left: 251,
                                width: 34,
                                height: 35,
                                hideCenterPoint: 1,
                                answerPosition: 'right',
                                answerKey: 'key2'
                            }
                        ],
                        options: [
                            {
                                value: 'key1',
                                label: 'option1',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-1.png"),
                            },
                            {
                                value: 'key2',
                                label: 'option2',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-2.png"),
                            },
                            {
                                value: 'key3',
                                label: 'option3',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-3.png"),
                            },
                            {
                                value: 'key4',
                                label: 'option4',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-4.png"),
                            },
                            {
                                value: 'key5',
                                label: 'option5',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-5.png"),
                            },
                            {
                                value: 'key6',
                                label: 'option6',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-6.png"),
                            },
                            {
                                value: 'key7',
                                label: 'option7',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-7.png"),
                            },
                        ],
                    },
                    {
                        // 拼图/组装
                        key: 'section2.7.41.1.2.3', // *必填* 唯一标识
                        actionType: 4, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                        cover: require("@/assets/images/books/book1/action/jigsaw-back-3.png"),
                        width: 662,
                        height: 362,
                        content: [
                            {
                                top: 23,
                                left: 555,
                                width: 34,
                                height: 35,
                                hideCenterPoint: 1,
                                answerPosition: 'left',
                                answerKey: 'key3',
                                radioPosition: 'left'
                            },
                        ],
                        options: [
                            {
                                value: 'key1',
                                label: 'option1',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-1.png"),
                            },
                            {
                                value: 'key2',
                                label: 'option2',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-2.png"),
                            },
                            {
                                value: 'key3',
                                label: 'option3',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-3.png"),
                            },
                            {
                                value: 'key4',
                                label: 'option4',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-4.png"),
                            },
                            {
                                value: 'key5',
                                label: 'option5',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-5.png"),
                            },
                            {
                                value: 'key6',
                                label: 'option6',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-6.png"),
                            },
                            {
                                value: 'key7',
                                label: 'option7',
                                image: require("@/assets/images/books/book1/action/jigsaw-option-7.png"),
                            },
                        ],
                    },
                ]
            },
        ]
    },
    //任务实施1
    {
        key: 'section2.7.42',
        type: "taskEffect",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: '',
        content: [{
            key: 'section2.7.42.1', // *必填* 唯一标识
            category: 'popover',
            text: '任务实施 —— 辨识尺寸标注的正误',
            popText: '某大学毕业生张强的职业目标是成为一名优秀的机械工程技术人员，他最近参加了一家机械设计公司的面试，面试官为了检验他对国家标准的掌握情况，让他指出图样（见图1-1）中的错误。请帮他指出该图样中的错误，并改正这些错误。',
            isreset: true, //是否显示重置按钮
            textStyle: {
                color: '#0482EC',
                fontSize: 28,
                lineHeight: 48,
                fontFamily: 'Microsoft YaHei',
                fontWeight: 'bold'
            },
            //参考答案的文字内容
            list: [
              {
                    key: 'section2.7.42.2', // *必填* 唯一标识
                    type: 'text',
                    listtContent: [{
                            key: 'section2.7.42.2.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '图', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                textIndent: 40
                            },
                        },
                        {
                            key: 'section2.7.42.2.2', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '1', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.2.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '-', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.2.4', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '1', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.2.5', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '中的错误如图', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.2.6', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '1', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.2.7', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '-', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.2.8', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '17', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.2.9', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '（', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.2.10', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'a', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.2.11', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '）所示，共有五处，具体如下。', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                    ]
                },
                {
                    key: 'section2.7.42.3', // *必填* 唯一标识
                    type: 'text',
                    listtContent: [{
                            key: 'section2.7.42.3.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '（', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                textIndent: 40
                            },
                        },
                        {
                            key: 'section2.7.42.3.2', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '1', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.3.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '）尺寸数字', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                textIndent: 40
                            },
                        },
                        {
                            key: 'section2.7.42.3.4', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'R20', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.3.5', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '上不得通过任何图线，若无法避免，必须将图线断开或将尺寸数字从尺寸线引出标注。', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                textIndent: 40
                            },
                        },
                    ]
                },
                {
                    key: 'section2.7.42.4', // *必填* 唯一标识
                    type: 'text',
                    listtContent: [{
                            key: 'section2.7.42.4.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '（', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.4.2', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '2', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.4.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '）尺寸数字', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.4.4', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '20', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.4.5', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '表示直径，应在该直径的尺寸数字前加注直径符号“', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.4.6', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'EUCSYMBI'
                            },
                        },

                        {
                            key: 'section2.7.42.4.7', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '”，且尺寸数字应注写在尺寸线延长线的上方。', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                    ]
                },
                {
                    key: 'section2.7.42.5', // *必填* 唯一标识
                    type: 'text',
                    listtContent: [{
                            key: 'section2.7.42.5.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '（', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.5.2', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '3', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.5.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '）尺寸数字', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.5.4', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '60°', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.5.5', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '表示角度，表示角度的尺寸数字应水平注写。', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                    ]
                },
                {
                    key: 'section2.7.42.6', // *必填* 唯一标识
                    type: 'text',
                    listtContent: [{
                            key: 'section2.7.42.6.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '（', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.6.2', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '4', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.6.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '）尺寸数字', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.6.4', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '50', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.6.5', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '处的尺寸线不能画在其他图线的延长线上。', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                    ]
                },
                {
                    key: 'section2.7.42.7', // *必填* 唯一标识
                    type: 'text',
                    listtContent: [{
                            key: 'section2.7.42.7.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '（', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.7.2', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '5', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.7.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '）尺寸数字', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.7.4', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '56、16', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.7.5', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '的标注不符合“小尺寸在内、大尺寸在外”的原则。', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                    ]
                },
                {
                    key: 'section2.7.42.8', // *必填* 唯一标识
                    type: 'text',
                    listtContent: [{
                            key: 'section2.7.42.8.1', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '正确的尺寸标注如图', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.8.2', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '1-17', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.8.3', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '（', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                        {
                            key: 'section2.7.42.8.4', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: 'b', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                                fontFamily: 'Times New Roman',
                            },
                        },
                        {
                            key: 'section2.7.42.8.5', // *必填* 唯一标识
                            category: 'text', // *必填* 内容类型 text：文本
                            text: '）所示。', // *必填* 文本内容
                            textStyle: {
                                color: '#333333',
                                fontSize: device.isMobile ? 26 : 18,
                            },
                        },
                    ]
                }
            ],
            image: {
                key: 'section2.7.42.9', // *必填* 唯一标识
                src: require("@/assets/images/books/book1/1-17.jpg"), // *必填* 图片地址
                category: 'image',
                style: {
                    width: 642,
                    height: 269,
                    marginTop: 35
                },
                text: [{
                    key: 'section2.7.42.10', // *必填* 唯一标识
                    category: '',
                    textStyle: {
                        color: ''
                    }
                }]
            },
            footertext: {
                key: 'section2.7.42.11', // *必填* 唯一标识
                category: 'text',
                text: '图1-17  图样改正',
                textStyle: {
                    color: '#666666',
                    fontSize: device.isMobile ? 20 : 16,
                    lineHeight: 48,
                    textAlign: 'center',
                    marginTop: 26
                },
                fontContent: [{
                        key: 'section2.7.42.11.1', // *必填* 唯一标识
                        category: '',
                        text: '图',
                        textStyle: {
                            color: '#666666',
                            fontSize: device.isMobile ? 20 : 16,
                        }
                    },
                    {
                        key: 'section2.7.42.11.2', // *必填* 唯一标识
                        category: '',
                        text: '1-17',
                        textStyle: {
                            color: '#666666',
                            fontSize: device.isMobile ? 20 : 16,
                            fontFamily: 'Times New Roman',
                        }
                    },
                    {
                        key: 'section2.7.42.11.3', // *必填* 唯一标识
                        category: '',
                        text: '图样改正',
                        textStyle: {
                            color: '#666666',
                            fontSize: device.isMobile ? 20 : 16,
                        }
                    },
                ]
            },
            answerContent: {
                key: 'section2.7.42.12', // *必填* 唯一标识
                src: require("@/assets/images/books/book1/answer1-17.png"), // *必填* 图片地址
                category: 'image',
                style: {
                    width: 604,
                    height: 462
                },
                list: [{
                        width: 60,
                        height: 60,
                        left: 49,
                        bottom: 78,
                        bgcolor: 'rgba(43,190,142,0.3)',
                        defaultbg: 'rgba(2, 129, 236, 0.3)',
                        type: 'correct'
                    },
                    {
                        width: 60,
                        height: 60,
                        left: 240,
                        bottom: 384,
                        bgcolor: 'rgba(43,190,142,0.3)',
                        defaultbg: 'rgba(2, 129, 236, 0.3)',
                        type: 'correct'
                    },
                    {
                        width: 60,
                        height: 60,
                        left: 260,
                        bottom: 245,
                        bgcolor: 'rgba(43,190,142,0.3)',
                        defaultbg: 'rgba(2, 129, 236, 0.3)',
                        type: 'correct'
                    },
                    {
                        width: 60,
                        height: 60,
                        left: 210,
                        bottom: 70,
                        bgcolor: 'rgba(43,190,142,0.3)',
                        defaultbg: 'rgba(2, 129, 236, 0.3)',
                        type: 'correct'
                    },
                    {
                        width: 60,
                        height: 60,
                        left: 213,
                        bottom: 3,
                        bgcolor: 'rgba(244,132,80,0.3)',
                        defaultbg: 'rgba(2, 129, 236, 0.3)',
                        type: 'error'
                    },
                    {
                        width: 60,
                        height: 60,
                        left: 494,
                        bottom: 194,
                        bgcolor: 'rgba(244,132,80,0.3)',
                        defaultbg: 'rgba(2, 129, 236, 0.3)',
                        type: 'error'
                    },
                    {
                        width: 60,
                        height: 60,
                        left: 506,
                        bottom: 130,
                        bgcolor: 'rgba(43,190,142,0.3)',
                        defaultbg: 'rgba(2, 129, 236, 0.3)',
                        type: 'correct'
                    },
                    {
                        width: 60,
                        height: 60,
                        left: 558,
                        bottom: 92,
                        bgcolor: 'rgba(244,132,80,0.3)',
                        defaultbg: 'rgba(2, 129, 236, 0.3)',
                        type: 'error'
                    }
                ]
            },
        }, ]
    },
    //创想天地
    {
        key: 'section2.7.43',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_section', //
        titleBg: {
            key: 'section2.7.43.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_cxtd_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 66,
            },
        },
        content: [{
            key: 'section2.7.43.2', // *必填* 唯一标识
            category: 'frame_cxtd',
            textStyle: {
                color: '#1A1A1A',
                fontSize: device.isMobile ? 26 : 18,
                lineHeight: 44,
                textIndent: 20,
                fontFamily: 'SimSun',
            },
            fontContent: [{
                key: 'section2.7.43.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '常言道“无规矩不成方圆”，而标准就是指导生产活动的“规矩”。请查阅有关资料，了解标准在机械工程领域发挥着怎样的作用，讨论一下在日后的学习和工作中遵守标准的意义。', // *必填* 文本内容
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    lineHeight: 44,
                    fontFamily: 'SimSun',
                    fontWeight: 'bold',

                },
            }, ]
        }, ]
    },
    //笔记内容
    {
        key: 'section2.7.44',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '文旌数字教材', // *必填* 标题文本内容
        category: 'frame_textarea', //
        titleBg: {
            key: 'section2.7.44.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_note_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 48,
            },
        },
        content: [{
            key: 'section2.7.44.2', // *必填* 唯一标识
            category: '',
            hasBack: 1, // 是否存在背景 背景默认为白色背景黑色描边 1：存在 2：不存在
            placeholder: '请输入你的笔记',
            value: '',
            titleStyle: {

            }
        }, ]
    },
    //砥节砺行
    {
        key: 'section2.7.45',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_article_section',
        titleBg: {
            key: 'section2.7.45.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_djlx_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 43,
            },
        },
        content: [{
                key: 'section2.7.45.2', // *必填* 唯一标识
                textStyle: {
                    textAlign: 'center',
                    textIndent: ''
                },
                fontContent: [{
                    key: 'section2.7.45.2.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '发挥标准引领作用至为关键',
                    textStyle: {
                        color: '#1A1A1A',
                        fontSize: device.isMobile ? 28 : 20,
                        lineHeight: 44,
                        fontFamily: 'SimSun',
                        textAlign: 'center',
                        fontWeight: 'bold',
                    },
                }, ]
            },
            {
                key: 'section2.7.45.3', // *必填* 唯一标识
                textStyle: {
                    textAlign: '',
                    textIndent: 35
                },
                fontContent: [{
                    key: 'section2.7.45.3.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '标准引领是一个国家步入高质量发展、参与高质量竞争的重要标志。谁的技术成为标准，谁制定的标准为世界所认同，谁就能把握国际贸易的主动权、占领市场竞争的制高点。',
                    textStyle: {
                        color: '#1A1A1A',
                        fontSize: device.isMobile ? 26 : 18,
                        lineHeight: 44,
                        fontFamily: 'SimSun',
                    },
                }, ]
            },
            {
                key: 'section2.7.45.4', // *必填* 唯一标识
                textStyle: {
                    textAlign: '',
                    textIndent: 35
                },
                fontContent: [{
                        key: 'section2.7.45.4.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '我国一直高度重视标准化工作。截至目前，我国已发布国家标准',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.4.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '4.3',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.4.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '万项，备案行业标准',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.4.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '7.8',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.4.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '万项、地方标准',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.4.6', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '6.2',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.4.7', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '万项，自我声明公开团体标准',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.4.8', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '5.3',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.4.9', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '万项、企业标准',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.4.10', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '270',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.4.11', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '万项，特别是代表技术一流、管理先进、效益显著的企业标准“领跑者”达到',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.4.12', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '3 200',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.4.13', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '余项。',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                ]
            },
            {
                key: 'section2.7.45.5', // *必填* 唯一标识
                textStyle: {
                    textAlign: '',
                    textIndent: 35
                },
                fontContent: [{
                        key: 'section2.7.45.5.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '产业优化，标准先行。广大企业是市场经济的主体，是市场活力最集中的体现。',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.5.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '2022',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.5.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '年，企业标准“领跑者”新增“物流服务”“电子商务”“智能消费设备”等近',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.5.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '40',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.5.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '个重点领域，重点领域数达',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.5.6', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '240',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.5.7', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '个，为促进相关行业的高质量发展和转型升级发挥了积极作用。',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                ]
            },
            {
                key: 'section2.7.45.6', // *必填* 唯一标识
                textStyle: {
                    textAlign: '',
                    textIndent: 35
                },
                fontContent: [{
                        key: 'section2.7.45.6.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '质量提升，标准支承。近年来，相关部门协同合作、区域标准化工作亮点纷呈，“标准化+”行动在各行业广泛开展：工业标准不断提档升级，重点装备制造、新一代信息技术等领域国际标准转化率超过',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.6.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '90',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.6.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '%，主要消费品标准与国际标准一致性程度达到',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                    {
                        key: 'section2.7.45.6.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '95',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'Times New Roman'
                        },
                    },
                    {
                        key: 'section2.7.45.6.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '%；服务业标准体系持续完善；社会管理与公共服务领域标准化工作基本实现全覆盖……',
                        textStyle: {
                            color: '#1A1A1A',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontFamily: 'SimSun',
                        },
                    },
                ]
            },
            {
                key: 'section2.7.45.7', // *必填* 唯一标识
                textStyle: {
                    textAlign: '',
                    textIndent: 35
                },
                fontContent: [{
                    key: 'section2.7.45.7.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '以标准助力高技术创新、引领产业优化升级、支承高效能治理、促进高水平开放、满足人民美好生活需要，已日渐成为现实。',
                    textStyle: {
                        color: '#1A1A1A',
                        fontSize: device.isMobile ? 26 : 18,
                        lineHeight: 44,
                        fontFamily: 'SimSun',
                    },
                }, ]
            },
            {
                key: 'section2.7.45.8', // *必填* 唯一标识
                textStyle: {
                    textAlign: 'right',
                    textIndent: ''
                },
                fontContent: [{
                    key: 'section2.7.45.8.1', // *必填* 唯一标识
                    category: 'text', // *必填* 内容类型 text：文本
                    text: '（资料来源：中国经济网，作者：金观平，有改动）',
                    textStyle: {
                        color: '#999999',
                        fontSize: device.isMobile ? 22 : 14,
                        lineHeight: 42,
                        fontFamily: 'SimSun',
                        textAlign: 'right'
                    },
                }, ]
            },
        ]
    },
]
export default content
